import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraSearchRoute: InvariantJiraRoute = {
	name: 'jira-search',
	path: '/jira/search',
	exact: true,
};
